import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { BenefitsSection } from './components/BenefitsSection';
import { AudienceSection } from './components/AudienceSection';
import { CredibilitySection } from './components/CredibilitySection';
import { VideoSection } from './components/VideoSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import AboutPage from './pages/AboutPage';
import './App.css';

function HomePage() {
  return (
    <div>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <BenefitsSection />
        <AudienceSection />
        <CredibilitySection />
        <VideoSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
      </Routes>
    </Router>
  );
}

export default App;
